// extracted by mini-css-extract-plugin
export default {"form":"component_form__kSdt3","submitButton":"component_submitButton__X3wmD","actions":"component_actions__ekAyu","wrapper":"component_wrapper__MAZ60"};